/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Suggestion_ErrorInputs */



/**
* | output |
* | --- |
* | "Couldn’t write that for you. Please try again or write your own." |
*
* @param {Field_Suggestion_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const field_suggestion_error = /** @type {((inputs?: Field_Suggestion_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Suggestion_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das konnte nicht geschrieben werden. Bitte erneut versuchen oder selbst formulieren.")
	return /** @type {LocalizedString} */ ("Couldn’t write that for you. Please try again or write your own.")
});